import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { MemoryCapture } from 'store/api-slice/types'
import { v4 as uuidv4 } from 'uuid'

export type UpsellType = 'memoryCapture'

interface UpsellState {
    dates: string[]
    memoryCapture: MemoryCapture | null
    isAddingMemoryCaptureInProgress: boolean
}

const initialState: UpsellState = {
    dates: [],
    memoryCapture: null,
    isAddingMemoryCaptureInProgress: false,
}

const upsellSlice = createSlice({
    name: 'upsell',
    initialState,
    reducers: {
        setDates(state, action: PayloadAction<string[]>) {
            state.dates = action.payload
        },

        setUpsellQuantity(
            state,
            action: PayloadAction<{
                quantity: number
                type: UpsellType
            }>
        ) {
            const { quantity, type } = action.payload
            state[type] = { ...state[type], quantity }
        },

        addUpsell(
            state,
            action: PayloadAction<{
                data: MemoryCapture
                type: UpsellType
            }>
        ) {
            const { data, type } = action.payload
            let productType: MemoryCapture['productType']

            switch (type) {
                case 'memoryCapture':
                    productType = 'memory_capture'
                    break
            }

            state[type] = {
                ...data,
                cartItemId: data.cartItemId || uuidv4(),
                quantity: data.quantity || 0,
                productType,
            }
        },

        removeUpsell(state, action: PayloadAction<UpsellType>) {
            const type = action.payload
            state[type] = null
        },

        updateUpsell(
            state,
            action: PayloadAction<{ type: UpsellType; quantity: number }>
        ) {
            const { type, quantity } = action.payload

            state[type] = {
                ...state[type],
                quantity,
                cartItemId: uuidv4(),
            }
        },

        setIsAddingMemoryCaptureInProgress(
            state,
            action: PayloadAction<boolean>
        ) {
            state.isAddingMemoryCaptureInProgress = action.payload
        },
    },
})

export const {
    setDates,
    addUpsell,
    removeUpsell,
    setUpsellQuantity,
    updateUpsell,
    setIsAddingMemoryCaptureInProgress,
} = upsellSlice.actions
export default upsellSlice.reducer
